import { render, staticRenderFns } from "./MedicalLeavesView.vue?vue&type=template&id=2cea6692"
import script from "./MedicalLeavesView.vue?vue&type=script&lang=js"
export * from "./MedicalLeavesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports